import * as Dialog from '@radix-ui/react-dialog'
import React, { useState } from 'react'
import { CarSortEnum, CarSortLabelEnum } from '../../../../../types/enums'
import { Icon } from '../../../../shared/ui/icons/Icon'

type SortProps = {
  currentSort: string
  onSortChange: (sortValue: string) => void
  isMobile?: boolean
}

export default function SortButton({
  currentSort,
  onSortChange,
  isMobile,
}: SortProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const sortOptions = [
    {
      label: CarSortLabelEnum[CarSortEnum.PRICE_ASC],
      value: CarSortEnum.PRICE_ASC,
    },
    {
      label: CarSortLabelEnum[CarSortEnum.PRICE_DESC],
      value: CarSortEnum.PRICE_DESC,
    },
    { label: CarSortLabelEnum[CarSortEnum.KM_ASC], value: CarSortEnum.KM_ASC },
    {
      label: CarSortLabelEnum[CarSortEnum.MATRICULATION_DESC],
      value: CarSortEnum.MATRICULATION_DESC,
    },
    {
      label: CarSortLabelEnum[CarSortEnum.MATRICULATION_ASC],
      value: CarSortEnum.MATRICULATION_ASC,
    },
  ]

  const handleSortChange = (value: string) => {
    onSortChange(value)
    setIsDialogOpen(false)
  }

  return (
    <Dialog.Root open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <div className="relative">
        <Dialog.Trigger asChild>
          <button
            className={`
              flex w-full items-center justify-center border border-neutral-100
              px-4 py-3

              ${isDialogOpen ? 'bg-neutral-75' : ''}
              ${isMobile ? 'h-[45px] text-subtitle1-bold' : 'rounded-full'}

              bg-white

              lg:bg-transparent
            `}
          >
            {isMobile ? (
              <>
                <span>Ordenar por </span>
                <Icon
                  name="basic/chevron-down"
                  className={`
                    mr-2 text-black transition duration-200

                    ${isDialogOpen ? 'rotate-180' : ''}
                  `}
                  size="16px"
                />
              </>
            ) : (
              <>
                <p className="mr-2 text-subtitle1-bold">Ordenar por</p>
                <Icon
                  name="basic/chevron-down"
                  className={`
                    text-black transition duration-200

                    ${isDialogOpen ? 'rotate-180' : ''}
                  `}
                  size="16px"
                />
              </>
            )}
          </button>
        </Dialog.Trigger>

        <Dialog.Content
          className={`
            absolute right-0 top-full z-50 mt-1 w-72 rounded-[16px] bg-white p-0
            pb-4 pt-4 shadow-lg
          `}
        >
          <div className="flex flex-col">
            {sortOptions.map((option) => (
              <React.Fragment key={option.value}>
                <button
                  className={`
                    w-full px-4 py-3 text-left text-subtitle1-medium
                    text-neutral-900 transition-colors

                    ${
                      currentSort === option.value
                        ? `
                          bg-primary-500 text-white

                          hover:bg-primary-600
                        `
                        : `
                          text-gray-700

                          hover:bg-neutral-50
                        `
                    }
                  `}
                  onClick={() => handleSortChange(option.value)}
                >
                  {option.label}
                </button>
              </React.Fragment>
            ))}
          </div>
        </Dialog.Content>
      </div>
    </Dialog.Root>
  )
}
